import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusPanel } from '../../../components/StatusPanel';
import { apiErrorMessageKey } from '../../../lib/api';
import { AuthPendingStatus } from '../components/AuthPendingStatus';

export function ImpersonatePending(): ReactElement {
    const { t } = useTranslation();
    return <AuthPendingStatus label={t('IMPERSONATION.CONSUME_PENDING')} />;
}

export function ImpersonateError({ error }: { error: unknown }): ReactElement {
    const { t } = useTranslation();
    return (
        <StatusPanel
            severity="error"
            title={t(apiErrorMessageKey(error, 'ERRORS.IMPERSONATION_FAILED'))}
            body={<Typography variant="body2">{t('IMPERSONATION.CONSUME_ERROR_HINT')}</Typography>}
        />
    );
}
